import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-resize-corner",
  templateUrl: "./resize-corner.component.html",
  standalone: false,
})
export class ResizeCornerComponent {
  @Output() resize = new EventEmitter<MouseEvent>();

  onMouseDown(event: MouseEvent): void {
    this.resize.emit(event);
  }
}
